import React, { useState } from 'react';
import cross from '../images/ImageUpload/cross.png'
import PanoramaViewer from './PanoramaViewer'

function ModalImage({ imageUrl, onClose, mobile }) {

  return (
    <div className="w-screen h-screen absolute inset-0 flex justify-center items-center bg-[#000] bg-opacity-75 p-10 z-[8888] overflow-hidden" onClick={onClose}>
      <div className="w-full h-full flex justify-center items-center gap-3">
        <div className='w-full h-full flex justify-center items-center'>
          <img
            src={imageUrl}
            alt="Modal"
            className={`${mobile ? 'h-max' : 'h-full'} object-fill`}
          />
        </div>
        <div className='absolute right-10 top-10 rounded-full flex justify-center items-center bg-white p-0 cursor-pointer' onClick={onClose}>
            <img className='w-10' src={cross} alt="" />
        </div>
      </div>
      {/* <div className="w-full h-full">
        <PanoramaViewer imageUrl={imageUrl} />
        </div> */}

    </div>
  );
}

export default ModalImage;